<template>
  <div class="background--alt">
  </div>
</template>

<script>
export default {
  name: "Header"
};
</script>
